<template>
  <v-dialog hide-overlay max-width="1350px" v-model="homeworkDetailsDialog">
    <v-card class="grey-bx pa-5 pb-16" color="background">
      <v-card-text>
        <v-row justify="space-around" class="align-center ml-2">
          <v-col cols="10">
            <v-row class="align-center">
              <v-icon class="mr-3"> mdi-note-multiple-outline </v-icon>
              <span class="t-h4"> {{ currentHomework.title }} </span>
            </v-row>
          </v-col>
          <v-col align-self="end" class="text-end" offset="1" cols="1">
            <v-icon color="black" size="30" @click="homeworkDetailsDialog = false">
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
        <v-row class="mt-5 mb-6">
          <v-divider></v-divider>
        </v-row>
        <!-- Homework Details -->
        <v-row class="t-h5 px-4"> Homework Details </v-row>
        <v-row dense class="align-center mt-4 t-subtitle ma-0 pa-0">

          <v-col cols="auto" class="t-subtitle mx-4">
            Task Type: {{ getTaskType(currentHomework.homeworkTaskType) }}
          </v-col>
          <v-col cols="auto" class="t-subtitle mx-4">Starting:
            {{
              getDateTimeFromTimeStamp(currentHomework.startTimeStamp)
            }}</v-col>
          <v-col cols="auto" class="t-subtitle mx-4">Ending:
            {{
              getDateTimeFromTimeStamp(currentHomework.endTimeStamp)
            }}</v-col>
          <v-col cols="auto" class="t-subtitle mx-4">Attempt Allowed After EndTime:
            {{
              currentHomework.attemptAllowedAfterEndTime ? 'Yes' : 'No'
            }}</v-col>
        </v-row>
        <v-row dense class="align-center t-h6Reg ma-0 pa-0 mt-4">
          <v-col cols="12" class="t-subtitle-2">
            Homework Description :
          </v-col>
          <v-col cols="12" class="t-subtitle mx-4">
            <v-row class="overflow-auto px-4 mt-1">
              <HtmlRender class="htmlClass" :html-string="currentHomework.description"></HtmlRender>
            </v-row>
          </v-col>
        </v-row>


        <v-row class="mt-5 mb-6">
          <v-divider></v-divider>
        </v-row>
        <!-- IF Homework Test Then details -->
        <div v-if="currentHomework.homeworkTaskType === 'Test'">

          <v-row class="t-h5 px-4"> Test Details </v-row>
          <v-row dense class="align-center t-h6Reg ma-0 pa-0 mt-5">
            <v-col cols="12" v-if="currentHomework.testData.subjects != null">
              {{ currentHomework.testData.subjects.toString() }}
            </v-col>
          </v-row>
          <v-row dense class="align-center t-subtitle ma-0 pa-0">
            <v-col cols="auto ">
              {{ currentHomework.testData.questionsCount }} questions</v-col>
            <v-col cols="auto" class="mx-2">
              <v-icon>mdi-clock-outline</v-icon>
              {{ currentHomework.testData.testDurationInMinutes }} mins</v-col>

            <v-col cols="auto" class="t-subtitle mx-2">Starting:
              {{
                getDateTimeFromTimeStamp(currentHomework.testData.startTimeStamp)
              }}</v-col>
          </v-row>
          <v-divider class="my-8"> </v-divider>
          <v-row class="t-h5 px-4"> Test Syllabus </v-row>
          <v-row class="px-4 mt-6">
            <HtmlRender class="htmlClass" :html-string="currentHomework.testData.syllabus"></HtmlRender>
          </v-row>
          <v-divider class="my-8"> </v-divider>
          <v-row class="t-h5 px-4"> Test Instructions </v-row>
          <v-row class="px-4 mt-6">
            <HtmlRender class="htmlClass" :html-string="currentHomework.testData.instructions"></HtmlRender>
          </v-row>
        </div>

        <div v-if="currentHomework.homeworkTaskType === 'Content'">

          <v-row class="t-h5 px-4"> Content Details </v-row>
          <v-row dense class="align-center t-subtitle ma-0 pa-0 mt-5">
            <v-col cols="12" class="t-subtitle mx-2">Content Type :
              {{
                currentHomework.contentType
              }}</v-col>
            <v-col cols="12" class="t-subtitle mx-2">Name :
              {{
                currentHomework.contentItems[0].name
              }}</v-col>

          </v-row>
        </div>


        <div v-if="currentHomework.homeworkTaskType === 'Subjective'">

          <v-row class="t-h5 px-4"> Subjective Details </v-row>
          <v-row dense class="align-center t-subtitle ma-0 pa-0 mt-5">
            <v-col cols="auto" class="t-subtitle mx-2">
              Subject : {{ currentHomework.subjectName }}
            </v-col>
            <v-col cols="auto" class="t-subtitle mx-2">
              Topic : {{ currentHomework.topicName }}
            </v-col>
            <v-col cols="auto" class="t-subtitle mx-2" v-if="currentHomework.showMarksAfterReview">
              Scoring Criteria : {{ currentHomework.scoringCriteria }}
            </v-col>
            <v-col cols="auto" class="t-subtitle mx-2"
              v-if="currentHomework.showMarksAfterReview && currentHomework.scoringCriteria === 'Marks'">
              Maximum Marks : {{ currentHomework.maximumMarks }}
            </v-col>
          </v-row>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>

  <v-container v-if="showData" fluid class="bg-background ma-0 pa-4">
  </v-container>
  <v-container v-else fluid class="bg-background ma-0 pa-4">

    <div v-if="currentParentType === 'subjectiveHomework'">
      <v-row class="ma-0 pa-0" align="center">
        <v-btn class="ma-0 mr-2" color="secondary" size="x-small" @click="back" icon="mdi-chevron-left">
        </v-btn>
        <v-col class="ma-0 pa-0">
          <v-icon icon="mdi-bookshelf" color="primary" class="ml-2 mb-1"></v-icon>
          <span class="ml-2 text-h6 mt-6">{{ currentHomework.title }}</span>
        </v-col>
        <v-col align="end">
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-bottom-sheet :persistent="disableSubjectiveSubmitButtom" v-model="bottomSheet">
                <template v-slot:activator="{ props }">
                  <v-btn v-if="currentHomework.isCompleted ? !currentHomework.isCompleted : true"
                    prepend-icon="mdi-book-edit" color="success" variant="outlined" v-bind="props"
                    text="Submit"></v-btn>
                </template>

                <v-card subtitle="" title="Upload your Homework">
                  <template v-slot:prepend>
                    <v-avatar v-if="currentHomework.studentDocumentUploadType === 'Link'" color="blue-darken-2">
                      <v-icon icon="mdi-link-variant"></v-icon>
                    </v-avatar>
                    <v-avatar v-if="currentHomework.studentDocumentUploadType === 'Image / PDF'" color="blue-darken-2">
                      <v-icon icon="mdi-file-document-outline"></v-icon>
                    </v-avatar>
                    <v-avatar v-if="currentHomework.studentDocumentUploadType === 'All'" color="blue-darken-2">
                      <v-icon v-if="documentUplaodType === 'Link'" icon="mdi-link-variant"></v-icon>
                      <v-icon v-else icon="mdi-file-document-outline"></v-icon>
                    </v-avatar>
                  </template>

                  <template v-slot:append>
                    <v-btn @click="handleSubjectiveHomeworkSubmit" :disabled="disableSubjectiveSubmitButtom"
                      color="success" text="Submit"></v-btn>
                  </template>
                  <v-card-text v-if="currentHomework.studentDocumentUploadType === 'Link'">
                    <v-row dense>
                      <v-col dense class="mt-3" cols="8">
                        <v-text-field maxlength="150" :rules="requiredRule" prepend-icon="mdi-link-variant" dense
                          label="Please enter a valid Link here*" v-model="studentUploadLink"
                          variant="outlined"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text v-if="currentHomework.studentDocumentUploadType === 'Image / PDF'">
                    <v-row dense>
                      <v-col dense class="mt-3" cols="8">
                        <v-file-input :rules="fileSizeRule" @click:clear="onClearClicked"
                          :messages="uploadErrorMessage.length > 0 ? uploadErrorMessage : disableSubjectiveSubmitButtom ? 'Uploading Document!' : ''"
                          :loading="disableSubjectiveSubmitButtom ? 'primary' : false" variant="outlined"
                          :error="uploadErrorMessage.length > 0" :color="uploadErrorMessage.length > 0 ? 'red' : 'blue'"
                          v-model="inputFile" label="Upload document here*" accept=".jpg, .jpeg, .png, .pdf"
                          id="upload-input" truncate-length="30"></v-file-input>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text v-if="currentHomework.studentDocumentUploadType === 'All'">
                    <v-row dense>
                      <v-col dense cols="8">
                        <v-radio-group class="radio_input" dense inline label="Please select your document upload type"
                          v-model="documentUplaodType">
                          <v-radio dense label="Link" value="Link"></v-radio>
                          <v-radio dense label="Image / PDF" value="Image / PDF"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row dense v-if="documentUplaodType === 'Link'">
                      <v-col dense class="mt-3" cols="8">
                        <v-text-field maxlength="150" v-model="studentUploadLink" :rules="requiredRule"
                          prepend-icon="mdi-link-variant" dense label="Please enter a valid Link here*"
                          variant="outlined"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense v-if="documentUplaodType === 'Image / PDF'">
                      <v-col dense class="mt-3" cols="8">
                        <v-file-input :rules="fileSizeRule" @click:clear="onClearClicked"
                          :messages="uploadErrorMessage.length > 0 ? uploadErrorMessage : disableSubjectiveSubmitButtom ? 'Uploading Document!' : ''"
                          :loading="disableSubjectiveSubmitButtom ? 'primary' : false" variant="outlined"
                          :error="uploadErrorMessage.length > 0" :color="uploadErrorMessage.length > 0 ? 'red' : 'blue'"
                          v-model="inputFile" label="Upload document here*" accept=".jpg, .jpeg, .png, .pdf"
                          id="upload-input" truncate-length="30"></v-file-input>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-bottom-sheet>
            </v-form>
          </v-container>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-container class="mt-4 ma-0 pa-0">
        <v-row dense class="ml-2 text-subtitle-1 font-weight-bold mb-2">
          <v-col>
            Subject : {{ currentHomework.subjectName }}
          </v-col>
          <v-col>
            Topic : {{ currentHomework.topicName }}
          </v-col>
          <v-col v-if="currentHomework.showMarksAfterReview">
            Scoring Criteria : {{ currentHomework.scoringCriteria }}
          </v-col>
          <v-col v-if="currentHomework.showMarksAfterReview && currentHomework.scoringCriteria === 'Marks'">
            Maximum Marks : {{ currentHomework.maximumMarks }}
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0 mb-2" justify="start" v-if="currentHomework.isCompleted === true">
          <v-col>
            <div>
              <v-row class="ml-0 pa-0 flex align-center justify-start">
                <span :class="currentHomework.isReviewed === true ? 'text-green bx-big' : 'text-red bx-big'">
                  Review Status :
                  <div class="marks-obtained">
                    {{ currentHomework.isReviewed === true ? 'Done' : 'Pending' }}
                  </div>
                </span>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" justify="start">
          <v-col cols="12">
            <v-row dense align="start" justify="end">
              <v-col cols="12">
                <span class="text-subtitle-2 font-weight-bold">
                  Homework Description:
                </span>
              </v-col>
              <v-col cols="12">
                <v-row class="overflow-auto px-4 mt-1">
                  <HtmlRender class="htmlClass" :html-string="this.currentHomework.description"></HtmlRender>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="currentHomework.documentType === 'PDF' || currentHomework.documentType === 'Image'" dense
              align="start" justify="start">
              <v-col class="pt-8" cols="4">
                <v-card color="secondary" max-width="500"
                  @click="openDocumentInSubjective(currentHomework.documentType)">
                  <v-card-item>
                    <div class="text-subtitle-1">
                      {{ documentName }}
                    </div>
                  </v-card-item>
                </v-card>
              </v-col>
              <v-col class="pt-8" cols="2">
                <v-btn color="secondary" class="mt-1 ml-4" density="comfortable"
                  @click="downloadPDFDocumentInSubjective" icon="mdi-download">
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="currentHomework.documentType === 'Link'" dense align="start" justify="start">
              <v-col class="pt-12" cols="4">
                <v-tooltip location="top" text="Open link in new window">
                  <template v-slot:activator="{ props }">
                    <v-card v-bind="props" color="secondary" append-icon="mdi-open-in-new"
                      :href="currentHomework.documentData.documentLink" max-width="344" prepend-icon="mdi-link-variant"
                      rel="noopener" target="_blank" title="Link">
                    </v-card>
                  </template>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <div v-if="currentHomework.isCompleted === true" class="mt-6">
          <v-row class="ma-0 pa-0 flex align-center justify-start">
            <div class="text-subtitle-1 font-weight-bold text-grey-darken-1">
              Your Response
            </div>
            <v-divider></v-divider>
          </v-row>

          <!-- Student reponse  -->
          <v-row class="ml-0 pa-0 align-end" justify="start">
            <v-col cols="11">

              <v-row v-if="currentHomework.studentUploadType === 'Image/PDF'" dense align="start" justify="start">
                <v-col class="pt-4" cols="4">
                  <v-card color="secondary" max-width="500" @click="downloadStudentPDFDocumentInSubjective">
                    <v-card-item>
                      <div class="text-subtitle-1">
                        {{ currentHomework.studentDocumentData.s3DocumentName }}
                      </div>
                    </v-card-item>
                  </v-card>
                </v-col>
                <v-col class="pt-4" cols="2">
                  <v-btn color="secondary" class="mt-1 ml-4" density="comfortable"
                    @click="downloadStudentPDFDocumentInSubjective" icon="mdi-download">
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="currentHomework.studentUploadType === 'Link'" dense align="start" justify="start">
                <v-col class="pt-4" cols="4">
                  <v-tooltip location="top" text="Open link in new window">
                    <template v-slot:activator="{ props }">
                      <v-card v-bind="props" color="secondary" append-icon="mdi-open-in-new"
                        :href="currentHomework.studentDocumentData.s3DocumentURL" max-width="344"
                        prepend-icon="mdi-link-variant" rel="noopener" target="_blank" title="Link">
                      </v-card>
                    </template>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="currentHomework.studentResubmitDocumentAllowed && currentHomework.isReviewed !== true"
              cols="1">
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon="mdi-dots-vertical" elevation="0" v-bind="props"></v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in items" :key="index" :value="index">
                    <v-list-item-title @click="handleStudentDocumentUplaodItemMenuClick(index)" :class="item.color">{{
                      item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </div>


        <div v-if="currentHomework.isReviewed === true" class="mt-6">
          <v-row class="ma-0 pa-0 flex align-center justify-start">
            <div class="text-subtitle-1 font-weight-bold text-grey-darken-1">
              Reviewed Response
            </div>
            <v-divider></v-divider>
          </v-row>

          <!-- Reviewed reponse  -->
          <v-row class="ml-0 pa-0 align-end" justify="start">
            <v-col v-if="currentHomework.showMarksAfterReview" cols="12">
              <div v-if="currentHomework.scoringCriteria === 'Grade'">
                <v-row class="pa-0 ml-1 flex align-center justify-start text-green">
                  <span class="bx-big">
                    Grade Obtained :
                    <div class="marks-obtained">
                      {{ currentHomework.grade }}
                    </div>
                  </span>
                </v-row>
              </div>
              <div v-if="currentHomework.scoringCriteria === 'Marks'">
                <v-row class="pa-0 ml-1 flex align-center justify-start text-green">
                  <span class="bx-big">
                    Marks Obtained :
                    <div class="marks-obtained">
                      {{ currentHomework.marks }}
                    </div>
                  </span>
                </v-row>
              </div>
            </v-col>
            <v-col cols="12">
              <v-row
                v-if="currentHomework.reviewedDocumentData && currentHomework.reviewedDocumentData.s3DocumentURL !== null"
                dense align="start" justify="start">
                <v-col class="pt-4" cols="4">
                  <v-card color="secondary" max-width="500" @click="downloadReviewedPDFDocumentInSubjective">
                    <v-card-item>
                      <div class="text-subtitle-1">
                        {{ currentHomework.reviewedDocumentData.s3DocumentName.split("_")[1] }}
                      </div>
                    </v-card-item>
                  </v-card>
                </v-col>
                <v-col class="pt-4" cols="2">
                  <v-btn color="secondary" class="mt-1 ml-4" density="comfortable"
                    @click="downloadReviewedPDFDocumentInSubjective" icon="mdi-download">
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <span class="text-subtitle-2 font-weight-bold" cols="11">
                Reviewed Feedback:
              </span>
              <v-row class="overflow-auto mt-4 mb-8 px-4">
                <HtmlRender class="htmlClass" :html-string="currentHomework.reviewFeedback"></HtmlRender>
              </v-row>
            </v-col>
          </v-row>
        </div>

      </v-container>
    </div>

    <div v-if="currentParentType === 'homeworkList'">
      <v-row class="ma-0 pa-0" align="center">
        <v-col class="ma-0 pa-2 pb-4">
          <v-icon icon="mdi-bookshelf" color="primary" class="mr-2"></v-icon>
          <span>My Homeworks</span>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-container fluid class="mt-4 ma-0 pa-0 mr-5">

        <v-row dense class="mt-2 mb-6">
          <v-col :cols="$vuetify.display.width > 600 ? 7 : 12">
            <v-tabs color="transparent" v-model="tab" hide-slider mandatory align-tabs="start" show-arrows>
              <v-tab rounded @click="getHomeworksOnTabClick(index, item)" v-for="(item, index) in homeworksList"
                :ripple="false" :key="item.title" class="mx-3" :value="index">
                <v-chip color="transparent" centered class="px-5 py-5 active" v-if="tab === index">
                  <span class="homeworkTabSelected">
                    {{ item.taskStatusGroupName }}
                  </span>
                  <template v-slot:append>
                    <v-avatar color="white" size="25px" class="text-black">
                      {{ item.count }}
                    </v-avatar>
                  </template>
                </v-chip>
                <div v-else>
                  <v-row class="align-center px-2 pl-2">
                    <span class="homeworkTab">
                      {{ item.taskStatusGroupName }}
                    </span>
                    <v-avatar size="30px" color="#ECECEC" class="text-black mx-1">
                      {{ item.count }}
                    </v-avatar>
                  </v-row>
                </div>
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col class="mt-1" :cols="$vuetify.display.width > 600 ? 2 : 12">
            <v-select :items="[
              'All',
              'Test',
              'Video / PDFs (Content)',
              'Subjective Test through PDF / image',
            ]" density="compact" v-model="filterHomeworkType" label="Select Homework Type"
              variant="underlined"></v-select>
          </v-col>
          <v-col class="mt-1" v-if="$vuetify.display.width > 600" cols="3">
            <v-text-field elevation="0" v-model="searchText" clearable clear-icon="$close" density="compact"
              variant="underlined" label="Search Homework..." single-line hide-details append-inner-icon="mdi-magnify"
              @click:clear="clearSearch" class="search-box"></v-text-field>
          </v-col>
          <v-col :style="{ width: '100%' }" v-else>
            <v-text-field elevation="0" v-model="searchText" clearable clear-icon="$close" density="compact"
              variant="underlined" label="Search Homework..." single-line hide-details append-inner-icon="mdi-magnify"
              @click:clear="clearSearch" class="search-box"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-3" v-for="item in paginatedItems" :key="item.homeworkTaskId">
          <v-col cols="12">
            <v-hover v-slot="{ isHovering, props }">
              <v-card elevation="0" :class="{ 'on-hover': isHovering }" class="pa-4 homeworkCard" v-bind="props">
                <v-card-item>
                  <v-card-title class="t-h6">
                    <v-row class="align-center ma-0 pa-0">
                      {{ item.title }}
                      <span class="ml-4">
                        <v-tooltip text="View Homework Details" location="end">
                          <template v-slot:activator="{ props }">
                            <v-icon size="19" @click="viewHomeworkDetails(item)" v-bind="props" class="mb-0">
                              mdi-information-variant-circle-outline
                            </v-icon>
                          </template>
                        </v-tooltip>
                      </span>
                    </v-row>
                  </v-card-title>
                </v-card-item>

                <v-card-text class="t-subtitle-1">
                  <v-row class="align-center">
                    <v-col cols="12">
                      Task Type: {{ getTaskType(item.homeworkTaskType) }}
                    </v-col>
                  </v-row>
                  <v-row class="align-center" justify="start">
                    <v-col class="t-subtitle" cols="12" lg="3" offset="0">
                      Start Time:
                      {{ getDateTimeFromTimeStamp(item.startTimeStamp) }}
                    </v-col>
                    <v-col class="t-subtitle" cols="12" lg="3" offset="0">
                      {{
                        " End Time: " +
                        getDateTimeFromTimeStamp(item.endTimeStamp)
                      }}
                    </v-col>
                    <v-col cols="12" lg="5">
                      <v-row class="flex align-center ga-5" justify="start" justify-lg="end">
                        <v-col v-if="homeworkType === 'attempted' && item.homeworkTaskType !== 'Content'"
                          class="mt-1 ma-md-0 pa-md-0 text-left text-lg-right" cols="12" sm="6" md="6" lg="4" xl="4">
                          <v-btn class="btn-rd t-btn text-capitalize w-100" @click="viewHomeworkReport(item)"
                            elevation="0" color="secondary">
                            View Report
                          </v-btn>
                        </v-col>
                        <v-col
                          v-if="homeworkType === 'active' || (homeworkType === 'attempted' && item.homeworkTaskType === 'Test') || (homeworkType === 'attempted' && item.homeworkTaskType === 'Content') || (homeworkType === 'missed' && item.attemptAllowedAfterEndTime)"
                          class="mt-1 ma-md-0 pa-md-0 text-left text-lg-right" cols="12" sm="6" md="6" lg="4" xl="4">
                          <v-btn class="btn-rd t-btn text-capitalize w-100 " @click="startTask(item)" color="primary"
                            elevation="0">
                            {{ homeworkType === 'active' ? item.homeworkTaskType === 'Test' &&
                              item.testData.alreadyInProgress === true ? 'Resume Test' :
                              'Start Task' : item.homeworkTaskType === "Test" ?
                              'Practice Test' : item.homeworkTaskType === 'Content' &&
                                item.contentType === "video" ?
                                'Re-view Video' : item.contentType === "pdf" ?
                                  'Re-view PDF' :
                                  'Review Task' }}
                          </v-btn>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" lg="2" xl="2"
                          v-if="item.homeworkTaskType === 'Content' && item.contentType === 'pdf' && item.allowStudentsToDownloadPdf">
                          <v-btn color="secondary" density="comfortable"
                            @click="downloadContentPdf(item.contentItems[0])" icon="mdi-download">
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <div class="text-center mt-4">
          <v-pagination v-model="page" :length="pageCount" :total-visible="7" @input="onPageChange"></v-pagination>
        </div>
        <!-- <v-row class="flex align-center justify-center">
          <v-pagination v-model="page" :length="pageCount" :total-visible="7" @input="onPageChange"></v-pagination>
        </v-row> -->
      </v-container>
    </div>

    <!-- SHOW VIDEO AND PDF DIALOGS -->

    <template>
      <v-dialog v-model="ytVideoDialog" persistent width="auto">
        <v-card class="pa-1">
          <iframe :width="smAndUp ? 560 : 368" elevation="0" :height="smAndUp ? 315 : 207" :src="playVideoUrl"
            frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="text" @click="ytVideoDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="privateVideoDialog" persistent width="auto" ref="pvtVideoDialog">
        <v-card class="pa-1">
          <video id="videopId1" controls ref="privateVideoPlayer" :width="smAndUp ? 560 : 368" elevation="0"
            :height="smAndUp ? 315 : 207"></video>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="text" @click="privateVideoDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="pdfViewerDialog" persistent fullscreen>
        <v-card class="pa-1">
          <!--<PDFJSViewer :fileUrl='pdfFileUrl' />-->
          <!--<PDFVuer :fileUrl='pdfFileUrl' />-->
          <!--<PDFVuerSimple :fileUrl='pdfFileUrl'></PDFVuerSimple>-->
          <PDFJSExpressViewer :fileUrl="pdfFileUrl"></PDFJSExpressViewer>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="text" @click="pdfViewerDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
//import testsData from "./homeworkData.json";
import moment from "moment";
import HtmlRender from "@/components/Test/HtmlRender";
import PDFJSExpressViewer from "../learn/PDFJSExpressViewer.vue";
import { useDisplay } from "vuetify";
import Hls from "hls.js";
import { uploadImagePDFFile } from "@/services/storageService";
import { mapState } from "vuex";
import _ from "lodash";
import { AnalyticsEvents, recordAnalyticsEvent } from "@/services/awsPinpointAnalyticsService";

export default {
  name: "MyHomeworks",
  components: {
    HtmlRender,
    PDFJSExpressViewer,
  },
  setup() {
    // Destructure only the keys we want to use
    const { xs, smAndUp, mdAndUp } = useDisplay();

    return { xs, smAndUp, mdAndUp };
  },
  data: () => ({
    items: [
      { title: 'Modify Response', color: 'text-green-darken-1' }
    ],
    page: 1,
    itemsPerPage: 20,
    showData: false,
    bottomSheet: false,
    selectedItemIndex: -1,
    inputFile: null,
    selectedItemDescription: "",
    searchText: "",
    filterHomeworkType: "All",
    tab: 0,
    currentTab: {},
    homeworkDetailsDialog: false,
    currentHomework: {},
    ytVideoDialog: false,
    privateVideoDialog: false,
    pdfViewerDialog: false,
    download: false,
    pdfFileUrl: "",
    currentParentType: "homeworkList",
    documentUplaodType: "Link",
    fileSizeRule: [
      v => !!v || "File is required",
      v => !v || !v.length || v[0].size < 100000000 || "File size should be less than 100MB",
      v => !v || !v.length || /\.(jpg|jpeg|png|pdf)$/i.test(v[0].name) || "File type should be .jpg, .jpeg, .png or .pdf"
    ],
    requiredRule: [v => !!v || "Required"],
    disableSubjectiveSubmitButtom: false,
    uploadErrorMessage: "",
    studentUploadLink: "",
  }),

  watch: {
    tab() {
      this.page = 1;
    },
    inputFile() {
      this.uploadErrorMessage = "";
    },
    bottomSheet(val) {
      if (!val) {
        recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSubjectiveSubmitSheetClosed, {
          homeworkTaskId: this.currentHomework.homeworkTaskId,
          homeworkTitle: this.currentHomework.title,
        });
        if (this.inputFile !== null && !this.disableSubjectiveSubmitButtom)
          this.inputFile = null;
        this.studentUploadLink = "";
      } else {
        recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSubjectiveSubmitSheetOpened, {
          homeworkTaskId: this.currentHomework.homeworkTaskId,
          homeworkTitle: this.currentHomework.title,
        });
      }
    },
    pdfViewerDialog(val) {
      if (!val) {
        this.pdfFileUrl = "";
      }
    },
    privateVideoDialog(val) {
      if (!val) {
        if (this.pvtVideoDomControl) {
          this.pvtVideoDomControl.pause();
          //console.log(`this.pvtVideoDomControl.pause() called`);
          this.hlsInstance.detachMedia();
          //console.log(`hlsInstance.destroy() called`);
          this.hlsInstance.destroy();
          //console.log(`POST hlsInstance.destroy() call`);
          //console.log(`this.hlsInstance = null`);
          this.hlsInstance = null;
          //console.log(`POST this.hlsInstance = null`);
        }
      }
    },
    ytVideoDialog(val) {
      if (!val) {
        this.playVideoUrl = "";
      }
    },
  },
  async created() {
    this.$store.commit('appbarVisible', true);
    this.$store.commit('navbarVisible', true);
    this.$store.commit("removeTestFromStateHomework");
    recordAnalyticsEvent(AnalyticsEvents.v2HomeworkLoaded);
    this.getHomeworkData();
  },
  computed: {
    ...mapState(["profileInfo"]),
    documentName: {
      get() {
        let item = this.currentHomework.documentData.documentLink;
        if (item != null && item != "") {
          let tempString1 = item.split("/")[item.split("/").length - 1].split("_")[1];
          // let tempString2 = item.split("/").slice(2).join("/");
          // //console.log(tempString1 + "/" + tempString2);
          return tempString1;
        }
        return "No Data Available";
      },
      set() {
        return "No Data Available";
      }
    },
    homeworksList: {
      get() {
        return this.$store.state.homeworks;
      }
    },
    pageCount() {
      //console.log("pagecoutn", Math.ceil(this.filteredcurrentHomeworks.length / this.itemsPerPage))
      return Math.ceil(this.filteredcurrentHomeworks.length / this.itemsPerPage);
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredcurrentHomeworks.slice(start, end);
    },
    filteredcurrentHomeworks: {
      get() {
        if (this.filterHomeworkType === "Test") {
          let filterTestsOnType = this.homeworksList[this.tab].tasks.filter(
            (homework) => homework.homeworkTaskType === "Test"
          );
          if (this.searchText.trim().length > 0) {
            let filteredTest = this.filterTestsOnType.filter((o) => {
              return o.title
                .toLowerCase()
                .includes(this.searchText.trim().toLowerCase());
            });
            return filteredTest;
          } else {
            return filterTestsOnType;
          }
        } else if (this.filterHomeworkType === "Video / PDFs (Content)") {
          let filterTestsOnType = this.homeworksList[this.tab].tasks.filter(
            (homework) => homework.homeworkTaskType === "Content"
          );
          if (this.searchText.trim().length > 0) {
            let filteredTest = this.filterTestsOnType.filter((o) => {
              return o.title
                .toLowerCase()
                .includes(this.searchText.trim().toLowerCase());
            });
            return filteredTest;
          } else {
            return filterTestsOnType;
          }
        } else if (
          this.filterHomeworkType === "Subjective Test through PDF / image"
        ) {
          let filterTestsOnType = this.homeworksList[this.tab].tasks.filter(
            (homework) => homework.homeworkTaskType === "Subjective"
          );
          if (this.searchText.trim().length > 0) {
            let filteredTest = this.filterTestsOnType.filter((o) => {
              return o.title
                .toLowerCase()
                .includes(this.searchText.trim().toLowerCase());
            });
            return filteredTest;
          } else {
            return filterTestsOnType;
          }
        } else if (this.searchText.trim().length > 0) {
          let filteredTest = this.homeworksList[this.tab].tasks.filter((o) => {
            return o.title
              .toLowerCase()
              .includes(this.searchText.trim().toLowerCase());
          });
          return filteredTest;
        }

        return this.homeworksList[this.tab].tasks;
      },
    },
    homeworkType: {
      get(val) {
        console.log("prev Homework Type: ", val);
        return this.homeworksList[this.tab].taskStatusGroupName;
      },
    },
  },
  methods: {
    onPageChange(page) {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkPagination, {
        prevPage: this.page,
        currentPage: page,
        tab: this.tab,
      });
      this.page = page;
    },
    viewHomeworkReport(item) {
      //console.log(item.homeworkTaskType)
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkReportOpen, {
        homeworkTaskId: item.homeworkTaskId,
        homeworkTitle: item.title,
        homeworkTaskType: item.homeworkTaskType,
        tab: this.tab,
      });
      if (item.homeworkTaskType === 'Subjective') {
        this.currentHomework = item;
        this.currentParentType = "subjectiveHomework"
      } else if (item.homeworkTaskType === 'Test') {
        this.$store.commit("addTestToGetReports", item);
        this.currentHomework = item;
        this.$router.push(`/homework/${item.homeworkTaskId}/reports/${item.testData.testId}`);
      }

    },
    async getHomeworkData() {
      this.$store.commit('loading', true)
      this.showData = true
      //console.log("Get homework from server");
      this.$store.commit('homeworksLoadedFromServer', false)
      await this.$store.dispatch('loadHomeworks').then(() => {
        this.$store.dispatch('fetchProfileInfo').then(() => {
          this.$store.commit('loading', false)
          this.showData = false
        });
      }).catch(err => {
        console.log(err);
        this.$store.commit('loading', false)
      });
    },
    onClearClicked() {
      //console.log("cleared");
      this.uploadErrorMessage = "";
      this.inputFile = null;
    },
    async handleSubjectiveHomeworkSubmit() {
      //console.log("submit subjective")
      //console.log(this.inputFile)
      const validate = await this.$refs.form.validate();
      //console.log(validate);
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSubjectiveSubmited, {
        homeworkTaskId: this.currentHomework.homeworkTaskId,
        homeworkTitle: this.currentHomework.title,
        currentHomeworkUploadType: this.currentHomework.studentDocumentUploadType,
        stundemtUploadType: this.documentUplaodType,
        tab: this.tab,
      });

      if (validate.valid) {
        //console.log("valid")

        if (this.currentHomework.studentDocumentUploadType === "Link" || (this.currentHomework.studentDocumentUploadType === "All" && this.documentUplaodType === 'Link')) {
          this.inputFile = null;
          try {
            this.uploadErrorMessage = "";
            //console.log(this.currentHomework.homeworkTaskId);
            this.disableSubjectiveSubmitButtom = true;

            //console.log("upload complete", result);
            const reqData = {
              homeworkTaskId: this.currentHomework.homeworkTaskId,
              s3DocumentUrl: this.studentUploadLink,
              s3DocumentName: this.studentUploadLink,
              s3BucketName: '',
              documentType: "Link"
            }
            this.$store.dispatch('uploadS3SubjectiveHomework', reqData).then((response) => {
              //console.log("s3 upload", response);
              if (!response) {
                this.uploadErrorMessage = "Error while uploading. Please try again later."
                return;
              }
              if (response.error) {
                this.uploadErrorMessage = response.error;
                return;
              }
              this.$store.dispatch('submitHomeworkTask', { homeworkTaskId: this.currentHomework.homeworkTaskId, s3DocumentId: this.$store.state.homeworkDocumentS3Data.s3DocumentId }).then(async (resp) => {
                if (!resp) {
                  this.uploadErrorMessage = "Error while submiting. Please try again later."
                  return;
                }
                if (response.error) {
                  this.uploadErrorMessage = response.error;
                  return;
                }
                this.disableSubjectiveSubmitButtom = false;
                this.inputFile = null;
                this.bottomSheet = false;

                await this.getHomeworkData();
                this.back();
                this.tab = 1;
              })
            });

          } catch (err) {
            this.uploadErrorMessage = "Error while uploading. Please try again later."
            //console.log("error while uploading", err);
          } finally {
            this.disableSubjectiveSubmitButtom = false;
          }
          return;
        }

        if (this.inputFile === null) {
          return;
        }
        try {
          this.uploadErrorMessage = "";
          //console.log(this.currentHomework.homeworkTaskId);
          this.disableSubjectiveSubmitButtom = true;
          await uploadImagePDFFile(this.inputFile[0], this.profileInfo.organization, "VMCStudentDocuments", this.currentHomework.homeworkTaskId).then(async (result) => {

            //console.log("upload complete", result);
            const reqData = {
              homeworkTaskId: this.currentHomework.homeworkTaskId,
              s3DocumentUrl: result.key,
              s3DocumentName: result.name,
              s3BucketName: result.bucket,
              documentType: "Image/PDF"
            }
            this.$store.dispatch('uploadS3SubjectiveHomework', reqData).then((response) => {
              //console.log("s3 upload", response);
              if (!response) {
                this.uploadErrorMessage = "Error while uploading file. Please try again later."
                return;
              }
              if (response.error) {
                this.uploadErrorMessage = response.error;
                return;
              }
              this.$store.dispatch('submitHomeworkTask', { homeworkTaskId: this.currentHomework.homeworkTaskId, s3DocumentId: this.$store.state.homeworkDocumentS3Data.s3DocumentId }).then(async (resp) => {
                if (!resp) {
                  this.uploadErrorMessage = "Error while submiting document. Please try again later."
                  return;
                }
                if (resp.error) {
                  this.uploadErrorMessage = response.error;
                  return;
                }
                this.disableSubjectiveSubmitButtom = false;
                this.inputFile = null;
                this.bottomSheet = false;


                await this.getHomeworkData();
                this.back();
                this.tab = 1
              })
            });
          });

        } catch (err) {
          this.uploadErrorMessage = "Error while uploading file. Please try again later."
          //console.log("error while uploading", err);
        } finally {
          this.disableSubjectiveSubmitButtom = false;
        }
      }
    },
    downloadContentPdf(item) {
      let userAgent = navigator.userAgent;
      this.download = true;
      let pdfURL = item.pdfUrl ?? item.pdf.pdfUrl;
      this.$store.dispatch("getPdfUrl", pdfURL).then((pdf) => {
        if (userAgent.indexOf("Firefox") > -1) {
          console.log("In firefox");
          if (parent.window.open(pdf.url, "_blank") === null) {
            window.addEventListener("click", () => {
              console.log("Ok");
            });
            window.alert("Download Pdf");
          }
        } else {
          window.open(pdf.url, "_blank");
        }
        this.download = false;
      });
    },
    openDocumentInSubjective(type) {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSubjectiveTeacherDocumentOpen, {
        homeworkTaskId: this.currentHomework.homeworkTaskId,
        homeworkTitle: this.currentHomework.title,
        documentType: type,
        tab: this.tab,
      });
      if (type === 'PDF') {
        let pdfURL = this.currentHomework.documentData.documentLink;
        if (!this.download) {
          this.openPDFViewerInSubjective(pdfURL);
        }
      } else {
        this.downloadPDFDocumentInSubjective();
      }
    },
    openPDFViewerInSubjective(pdfURL) {
      this.$store.dispatch("getPdfUrl", pdfURL).then((pdf) => {
        this.pdfFileUrl = pdf.url;
        this.pdfViewerDialog = true;
      });
    },
    downloadPDFDocumentInSubjective() {
      let userAgent = navigator.userAgent;
      this.download = true;
      let pdfURL = this.currentHomework.documentData.documentLink;
      this.$store.dispatch("getPdfUrl", pdfURL).then((pdf) => {
        if (userAgent.indexOf("Firefox") > -1) {
          console.log("In firefox");
          if (parent.window.open(pdf.url, "_blank") === null) {
            window.addEventListener("click", () => {
              console.log("Ok");
            });
            window.alert("Download Pdf");
          }
        } else {
          window.open(pdf.url, "_blank");
        }
        this.download = false;
      });
    },
    // openStudentDocumentInSubjective() {
    //   let pdfURL = this.currentHomework.studentDocumentData.s3DocumentURL;
    //   if (!this.download) {
    //     this.openPDFViewerInSubjective(pdfURL);
    //   }
    // },
    openReviewedDocumentInSubjective() {
      let pdfURL = this.currentHomework.reviewedDocumentData.s3DocumentURL;
      if (!this.download) {
        this.openPDFViewerInSubjective(pdfURL);
      }
    },
    downloadReviewedPDFDocumentInSubjective() {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSubjectiveReviewedDocumentOpen, {
        homeworkTaskId: this.currentHomework.homeworkTaskId,
        homeworkTitle: this.currentHomework.title,
        s3DocumentId: this.currentHomework.reviewedDocumentData.s3DocumentId,
        tab: this.tab,
      });
      let userAgent = navigator.userAgent;
      this.download = true;
      let pdfURL = this.currentHomework.reviewedDocumentData.s3DocumentURL;
      this.$store.dispatch("getPdfUrl", pdfURL).then((pdf) => {
        if (userAgent.indexOf("Firefox") > -1) {
          console.log("In firefox");
          if (parent.window.open(pdf.url, "_blank") === null) {
            window.addEventListener("click", () => {
              console.log("Ok");
            });
            window.alert("Download Pdf");
          }
        } else {
          window.open(pdf.url, "_blank");
        }
        this.download = false;
      });
    },
    downloadStudentPDFDocumentInSubjective() {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSubjectiveStudentOwnUploadedDocumentOpen, {
        homeworkTaskId: this.currentHomework.homeworkTaskId,
        homeworkTitle: this.currentHomework.title,
        s3DocumentId: this.currentHomework.studentDocumentData.s3DocumentId,
        tab: this.tab,
      });
      let userAgent = navigator.userAgent;
      this.download = true;
      let pdfURL = this.currentHomework.studentDocumentData.s3DocumentURL;
      this.$store.dispatch("getPdfUrl", pdfURL).then((pdf) => {
        if (userAgent.indexOf("Firefox") > -1) {
          console.log("In firefox");
          if (parent.window.open(pdf.url, "_blank") === null) {
            window.addEventListener("click", () => {
              console.log("Ok");
            });
            window.alert("Download Pdf");
          }
        } else {
          window.open(pdf.url, "_blank");
        }
        this.download = false;
      });
    },
    handleStudentDocumentUplaodItemMenuClick(index) {
      //console.log(index);
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSubjectiveModifyDocuemntButtonClicked, {
        homeworkTaskId: this.currentHomework.homeworkTaskId,
        homeworkTitle: this.currentHomework.title,
        currentStudentDocuemntId: this.currentHomework.studentDocumentData.s3DocumentId,
        tab: this.tab,
      });
      if (index === 0) {
        this.bottomSheet = true;
      }
    },
    clearSearch() {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSearchUsed, {
        searchedtext: this.searchText
      });
      this.searchText = "";
    },
    back() {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkSubjectiveBackPressed, {
        homeworkTaskId: this.currentHomework.homeworkTaskId,
        homeworkTitle: this.currentHomework.title,
        tab: this.tab
      });
      this.currentParentType = "homeworkList";
      this.currentHomework = {};
    },
    getHomeworksOnTabClick(index, item) {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkTabSwitched, {
        prevTab: this.tab,
        currentTab: index
      });
      this.currentTab = item;
      this.tab = index;
    },
    getDateTimeFromTimeStamp(timestamp) {
      let date = new Date(timestamp);
      var dateString = moment(date).format("D MMM  YYYY	hh:mm A	");
      return dateString;
    },
    getTaskType(taskType) {
      if (taskType === "Test") {
        return "Test";
      } else if (taskType === "Content") {
        return "Video / PDFs (Content)";
      } else if (taskType === "Subjective") {
        return "Subjective Test through PDF / image";
      }
    },
    viewHomeworkDetails(item) {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkDetailsOpened, {
        homeworkTaskId: item.homeworkTaskId,
        homeworkTitle: item.title,
        tab: this.tab
      });
      this.currentHomework = item;
      this.homeworkDetailsDialog = true;
      setTimeout(() => {
        window.MathJax.typesetPromise();
      }, 10);
    },
    startTask(item) {
      recordAnalyticsEvent(AnalyticsEvents.v2HomeworkStartTaskClicked, {
        homeworkTaskId: item.homeworkTaskId,
        homeworkTitle: item.title,
        homeworkTaskType: item.homeworkTaskType,
        tab: this.tab,
      });
      if (item.homeworkTaskType === "Content") {
        if (this.isVideoContent(item)) {
          if (this.homeworkType === 'attempted') {
            if (
              (item.contentItems[0].videoType && item.contentItems[0].videoType.toLowerCase() == "youtube") ||
              (item.contentItems[0].video.videoType && item.contentItems[0].video.videoType.toLowerCase() == "youtube")
            ) {
              this.openYoutubeVideoPlayer(item.contentItems[0]);
            } else if (
              (item.contentItems[0].videoType && item.contentItems[0].videoType.toLowerCase() == "s3") ||
              (item.contentItems[0].video.videoType && item.contentItems[0].video.videoType.toLowerCase() == "s3")
            ) {
              this.openprivateVideoPlayer(item.contentItems[0]);
            }
          } else {
            this.$store.dispatch('submitHomeworkTask', { homeworkTaskId: item.homeworkTaskId }).then(async (resp) => {
              if (!resp) {
                return;
              }
              if (resp.error) {
                this.uploadErrorMessage = resp.error;
                return;
              }

              await this.getHomeworkData();
              this.tab = 1;

              if (
                (item.contentItems[0].videoType && item.contentItems[0].videoType.toLowerCase() == "youtube") ||
                (item.contentItems[0].video.videoType && item.contentItems[0].video.videoType.toLowerCase() == "youtube")
              ) {
                this.openYoutubeVideoPlayer(item.contentItems[0]);
              } else if (
                (item.contentItems[0].videoType && item.contentItems[0].videoType.toLowerCase() == "s3") ||
                (item.contentItems[0].video.videoType && item.contentItems[0].video.videoType.toLowerCase() == "s3")
              ) {
                this.openprivateVideoPlayer(item.contentItems[0]);
              }
            });
          }
        } else if (this.isPDFContent(item)) {
          if (this.homeworkType === 'attempted') {
            if (!this.download) {
              this.openPDfViewer(item);
            }
          } else {
            this.$store.dispatch('submitHomeworkTask', { homeworkTaskId: item.homeworkTaskId }).then(async (resp) => {
              if (!resp) {
                return;
              }
              if (resp.error) {
                this.uploadErrorMessage = resp.error;
                return;
              }

              await this.getHomeworkData();
              this.tab = 1;

              if (!this.download) {
                this.openPDfViewer(item);
              }
            });

          }
        }
      } else if (item.homeworkTaskType === "Test") {

        //console.log("TASK TYPE TEST");

        let body = _.cloneDeep(item.testData)

        body['isHomework'] = true;
        body['homeworkTaskId'] = item.homeworkTaskId;

        if (this.homworkType == 'attempted' || this.homworkType == 'missed') {
          body['isPractice'] = true;
        }
        this.$store.commit("updateSelectedTest", body)
        this.$store.commit("addTestToGetReports", item);
        this.$router.push(`/starttest/${item.testData.testId}?practice=${item.testData.isPractice}&homeworkTaskId=${item.homeworkTaskId}`)

      } else if (item.homeworkTaskType === "Subjective") {
        //console.log(item.homeworkTaskType)
        this.currentHomework = item;
        this.currentParentType = "subjectiveHomework"
        setTimeout(() => {
          window.MathJax.typesetPromise();
        }, 10);
      }
    },
    openPDfViewer(item) {
      //console.log(`inside openPDfViewer(item) : ${JSON.stringify(item)}`);
      let pdfURL = item.contentItems[0].pdfUrl ?? item.contentItems[0].pdf.pdfUrl;
      this.$store.dispatch("getPdfUrl", pdfURL).then((pdf) => {
        this.pdfFileUrl = pdf.url;
        this.pdfViewerDialog = true;
      });
    },
    openYoutubeVideoPlayer(item) {
      let regex =
        /(?:youtube(?:-nocookie)?\.com\/(?:[^\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      let itemYTURL = item.youTubeUrl ?? item.video.youTubeUrl;
      let temp = itemYTURL.match(regex)[1];
      const youtubeEmbedTemplate = "https://www.youtube.com/embed/";
      const topOfQueue = youtubeEmbedTemplate.concat(temp);
      this.playVideoUrl = topOfQueue;
      this.ytVideoDialog = true;
    },

    openprivateVideoPlayer(item) {
      // console.log(item.videoUrl)
      // console.log("Url : ", this.app_s3privateUrl)
      this.privateVideoDialog = true;
      this.$nextTick(function () {
        // console.log(`privateVideoDialog dom element loaded`);
        this.pvtVideoDomControl = this.$refs.privateVideoPlayer;
        // console.log(`this.pvtVideoDomControl 11 | ${this.pvtVideoDomControl}`);
        let videoURl = item.videoUrl ?? item.video.videoUrl;
        let stream = this.app_s3privateUrl + videoURl;

        console.log(`stream: ${stream}`);
        if (Hls.isSupported()) {
          console.log(`Hls.isSupported is true`);
          if (!this.hlsInstance) {
            var config = {
              xhrSetup: function (xhr, url) {
                console.log(`Hls config xhrSetup urk: ${url}`);
                xhr.withCredentials = true; // do send cookies
              },
            };
            this.hlsInstance = new Hls(config);
            console.log(`Created new Hls js instance  ${this.hlsInstance}`);
          } else {
            console.log(`reusing hls js instance: ${this.hlsInstance}`);
          }
          this.hlsInstance.loadSource(stream);
          this.hlsInstance.attachMedia(this.pvtVideoDomControl);
          this.hlsInstance.on(Hls.Events.MANIFEST_PARSED, function () {
            console.log(`inside Hls.Events.MANIFEST_PARSED, function ...`);
            let videoElement = document.getElementById(`videopId1`);
            console.log(`trying to play thls video: ${videoElement} `);
            videoElement.play();
          });
        } else if (
          this.pvtVideoDomControl.canPlayType("application/vnd.apple.mpegurl")
        ) {
          this.pvtVideoDomControl.src = stream;
        }
      });
    },
    isVideoContent(item) {
      let isVideoContent = false;
      if (item.contentType === "video") {
        isVideoContent = true;
      }
      return isVideoContent;
    },
    isPDFContent(item) {
      let isPdfContent = false;
      if (item.contentType === "pdf") {
        isPdfContent = true;
      }
      return isPdfContent;
    },
    downloadPDF(item) {
      let userAgent = navigator.userAgent;
      this.download = true;
      let pdfURL = item.pdfUrl ?? item.pdf.pdfUrl;
      this.$store.dispatch("getPdfUrl", pdfURL).then((pdf) => {
        if (userAgent.indexOf("Firefox") > -1) {
          console.log("In firefox");
          if (parent.window.open(pdf.url, "_blank") === null) {
            window.addEventListener("click", () => {
              console.log("Ok");
            });
            window.alert("Download Pdf");
          }
        } else {
          window.open(pdf.url, "_blank");
        }
        this.download = false;
      });
    },
  },
};
</script>

<style>
.active {
  background: rgb(var(--v-theme-primary)) !important;
  color: white;
}

.v-radio-group .v-input__details {
  display: none;
}

.non-active {
  background: #f3f2f3;
}

.v-tab {
  text-transform: none !important;
  text-transform: capitalize !important;
}

v-tab:hover {
  background-color: transparent !important;
  background-color: green !important;
}

.homeworkCard {
  box-shadow: 0px 2px 16px rgba(15, 27, 38, 0.1);
  border-radius: 12px;
  background-color: rgb(var(--v-theme-navColor));
  border: 1px solid #e7e7e7;
}

.homeworkTabSelected {
  font-family: "Inter", sans-serif !important;
  color: white !important;
  font-size: 0.875rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
}

.homeworkTab {
  font-family: "Inter", sans-serif !important;
  font-size: 0.875rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: #323232 !important;
}

.marks-obtained {
  margin-left: 25px;
}

.bx-big {
  display: flex;
  align-items: center;
  background-color: rgb(var(--v-theme-navColor));
  border: 1px solid #E7E7E7;
  border-radius: 4px;
  height: 20px;
  padding: 20px;
  font-size: 18px;
  max-width: 300px;
  margin-right: 20px;
}
</style>
